import React, { useState } from "react";
import "./Projects.css";
import SimpleSlider from "../../components/slider/SimpleSlider";

import Blog from "./logos/bareboneslogo.png";
import Clubs from "./logos/clubslogo.png";
import Emerald from "./logos/emeraldlogo.png";
import Gold from "./logos/goldlogo.png";
import Nool from "./logos/noollogo.png";
import Notion from "./logos/notionlogo.png";
import Pearl from "./logos/pearllogo.png";
import WhoIs from "./logos/whoislogo.png";
import Zentry from "./logos/zentrylogo.png";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

import blog1 from "./images/blog1.png";
import blog2 from "./images/blog2.png";
import blog3 from "./images/blog3.png";
import nool1 from "./images/nool1.png";
import nool2 from "./images/nool2.png";
import notion1 from "./images/notion1.png";
import notion2 from "./images/notion2.png";
import zentry1 from "./images/zentry1.png";
import zentry2 from "./images/zentry2.png";
import zentry3 from "./images/zentry3.png";
import zentry4 from "./images/zentry4.png";
import clubs1 from "./images/clubs1.png";
import clubs2 from "./images/clubs2.png";
import clubs3 from "./images/clubs3.png";
import clubs4 from "./images/clubs4.png";
import emerald1 from "./images/emerald1.png";
import emerald2 from "./images/emerald2.png";
import emerald3 from "./images/emerald3.png";
import gold1 from "./images/gold1.png";
import whois1 from "./images/whois1.png";

function Projects() {
  const [selectedProject, setSelectedProject] = useState(null);

  const handleOpen = (index) => {
    setSelectedProject(index);
  };

  const handleClose = () => {
    setSelectedProject(null);
  };

  const projects = [
    {
      name: "Clubs",
      logo: Clubs,
      shortDescription: "Social Network",
      description: `Developed a full-stack web application exclusively for 10,000+ LMU students, implementing restricted access through email authentication. The platform fosters seamless interaction and collaboration by enabling users to connect, share, and engage in a secure online environment with network-based discovery and real-time database updates.`,
      tools: "React JS, React Router, Styled Components, TailwindCSS, Firebase",
      link: "https://github.com/vahan-gev/projectclubs",
      images: [clubs1, clubs2, clubs3, clubs4],
    },
    {
      name: "Nool",
      logo: Nool,
      shortDescription: "Programming Language",
      description: `Created a high-level custom programming language with a unique thematic syntax, supporting object-oriented programming, arrays, control structures, and over 10 built-in functions. Optimized execution and enhanced the language’s overall efficiency by building a high-performance compiler with Ohm.js.`,
      tools: "Node.js, JavaScript, Ohm.js, C8",
      link: "https://github.com/vahan-gev/nool",
      images: [nool1, nool2],
    },
    {
      name: "Emerald",
      logo: Emerald,
      shortDescription: "2D Graphics Engine",
      description: `Developed a web-based 2D graphics engine that allows users to create interactive games and websites without modifying the engine code. The engine provides a seamless and dynamic development experience with built-in functions for animations, collision detection, event handling, audio playback, camera control, object transformations, texture handling, scene management, FPS tracking, and input handling.`,
      tools: "JavaScript, React.js, WebGL, GLSL",
      link: "https://github.com/vahan-gev/projectemerald",
      images: [emerald1, emerald2, emerald3],
    },
    {
      name: "Notion",
      logo: Notion,
      shortDescription: "Full Stack Clone",
      description: `Engineered a full-stack clone of Notion, incorporating rich text editing and real-time data synchronization to enhance the user experience. Also created a responsive and intuitive platform for smooth collaboration by implementing efficient state management, secure user authentication, and seamless real-time updates.`,
      tools: "Next.js, TailwindCSS, Shadcn, Convex, Sonner, Zustand, Clerk",
      link: "https://github.com/vahan-gev/projectclubs",
      images: [notion1, notion2],
    },
    {
      name: "Not Bare Bones Blog",
      logo: Blog,
      shortDescription: "AI web blog",
      description: `Developed a full-stack blog application with features like post creation, editing, comments, likes, and AI-generated articles powered by Google PaLM API. Ensured secure access and a seamless user experience by integrating Firebase for real-time database management and authentication.`,
      tools: "JavaScript, React.js, Firebase, PaLM API",
      link: "https://github.com/vahan-gev/notbarebonesblog",
      images: [blog1, blog2, blog3],
    },
    {
      name: "Zentry",
      logo: Zentry,
      shortDescription: "Frontend Clone",
      description: `Developed a responsive frontend clone of Zentry.com, featuring dynamic animations and smooth transitions to create an engaging user experience. Closely replicated the original site's look and feel by incorporating interactive elements and a visually appealing design`,
      tools: "React.js, TailwindCSS, Gsap",
      link: "https://github.com/vahan-gev/zentry-clone",
      images: [zentry1, zentry2, zentry3, zentry4],
    },
    {
      name: "Gold",
      logo: Gold,
      shortDescription: "3D Graphics Engine",
      description: `Developed a 3D graphics engine capable of rendering basic shapes like cubes, cones, spheres, and icosahedrons. Enhanced the engine's realism and flexibility by implementing light calculations with adjustable position and direction, along with support for loading 3D objects into the scene.`,
      tools: "JavaScript, React.js, WebGL, GLSL",
      link: "https://github.com/vahan-gev/gold",
      images: [gold1],
    },
    {
      name: "WhoIs",
      logo: WhoIs,
      shortDescription: "Face Recognition App",
      description: `Built a full-featured face recognition app, enabling real-time identity detection with a custom-trained dataset. Engineered a modular, GUI-based system with seamless face registration and optimized performance across Windows environments through precise dependency management.`,
      tools: "Python, OpenCV, Kivy",
      link: "https://github.com/vahan-gev/whois_python",
      images: [whois1],
    },
  ];

  return (
    <div className="InfoComponent">
      <h1 className="projects-intro">PROJECTS 🛠️</h1>
      <div className="projects-container">
        {projects.map((project, index) => (
          <div key={index} className="project-container">
            <div className="project-circle">
              <img
                onClick={() => handleOpen(index)}
                className="project-logo"
                src={project.logo}
                alt={project.logo}
              ></img>
              <p className="project-name">{project.name}</p>
              <p className="project-shortdescription">
                {project.shortDescription}
              </p>
            </div>
          </div>
        ))}
      </div>

      <Modal open={selectedProject !== null} onClose={handleClose}>
        <Box className="project-description-container">
          {selectedProject !== null && (
            <>
              <button onClick={handleClose} className="close-icon">
                <CloseIcon />
              </button>
              <h2 className="project-description-name">
                {projects[selectedProject].name}
              </h2>
              <p className="project-shortdescription">
                {projects[selectedProject].shortDescription}
              </p>
              <div className="project-slider-container">
                <SimpleSlider images={projects[selectedProject].images} />
              </div>
              <button
                onClick={() =>
                  window.open(projects[selectedProject].link, "_blank")
                }
                className="project-link"
              >
                Link
              </button>
              <div className="project-tools">
                <p className="project-tools-text">Tools:</p>
                <p className="project-tools-list">
                  {projects[selectedProject].tools}
                </p>
              </div>
              <p className="project-longdescription">
                {projects[selectedProject].description}
              </p>
            </>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default Projects;
